import React, { useEffect, useState } from 'react';
import {
    View,
    Text,
    ScrollView,
    ActivityIndicator,
    useWindowDimensions,
} from 'react-native';
import { useTranslation } from 'react-i18next';
import RenderHTML from 'react-native-render-html';
import { ImageComp } from '../../components/Image/Image';

import { CMSPath } from '../../config/Constant';
import { useCssStyle } from '../../customHook/getCssStyle';
import CustomPressable from '../../components/customPressable/customPressable';
import { useSelector } from 'react-redux';

const AD_HOC_IMG_PATH = '/cmsData/adhocEvents/imgStyles/';

const Adhoc_InHouse = (props) => {
    const { pendingRequest, acceptedRequest, handleUpsellRequest, adhocDataListLocalCopy, showSingleAdhoc, handleShowSingleAdhoc, handleBack, handleSkip } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const { width } = useWindowDimensions();

    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);

    const customGuestRequestMainTitleStyle = getStyles(['adhocOfferListItemMainHeaderTitleText']);
    const customGuestRequestMainSubTitleStyle = getStyles(['adhocOfferListItemMainHeaderSubTitleText']);

    const customGuestRequestTitleStyle = getStyles(['adhocOfferListItemHeaderTitleText']);
    const customGuestRequestSubTitleStyle = getStyles(['adhocOfferListItemHeaderSubTitleText']);
    

    const renderQualityPlusRequests = (adhoc) => {
        if (!adhoc.qualityPlusRequestList || adhoc.qualityPlusRequestList.length === 0) return null;

        return adhoc.qualityPlusRequestList.map((qp) => {
            const isPending = pendingRequest.some(r => adhoc.id == r.adhocId && adhoc.type == r.adhocType && qp.id === r.qualityPlusRequestId);
            const isAccepted = acceptedRequest.some(r => adhoc.id == r.adhocId && adhoc.type == r.adhocType && qp.id === r.qualityPlusRequestId);

            return (
                <View key={`${qp.id}`} style={getStyles(["adhocOfferListItemContainer"])} id='adhocOfferListItemContainer'>
                    {/* Top row: image + text */}
                    <View style={getStyles(["adhocOfferListItemSubHeaderContainer"])} id='adhocOfferListItemSubHeaderContainer'>
                        {!!qp.imageName && (
                            <ImageComp
                                source={`${CMSPath}${AD_HOC_IMG_PATH}${qp.imageName}`}
                                style={getStyles(["adhocOfferListItemSubHeaderImage"])}
                                id="adhocOfferListItemSubHeaderImage"
                            />
                        )}
                        <View style={getStyles(["adhocOfferListItemHeaderTextContainer"])} id='adhocOfferListItemHeaderTextContainer'>
                            <RenderHTML 
                                contentWidth={width}
                                source={{ html: qp.name || '' }} 
                                baseStyle={Array.isArray(customGuestRequestTitleStyle.fontFamilyArr) 
                                    ? {...customGuestRequestTitleStyle, fontFamily: customGuestRequestTitleStyle.fontFamilyArr[0]} 
                                    : customGuestRequestTitleStyle}
                                systemFonts={Array.isArray(customGuestRequestTitleStyle.fontFamilyArr) 
                                    ? customGuestRequestTitleStyle.fontFamilyArr 
                                    : [customGuestRequestTitleStyle.fontFamily]}
                                id={`adhocOfferListItemHeaderTitleText`}
                            />
                            <RenderHTML 
                                contentWidth={width}
                                source={{ html: qp.description || '' }} 
                                baseStyle={Array.isArray(customGuestRequestSubTitleStyle.fontFamilyArr) 
                                    ? {...customGuestRequestSubTitleStyle, fontFamily: customGuestRequestSubTitleStyle.fontFamilyArr[0]} 
                                    : customGuestRequestSubTitleStyle}
                                systemFonts={Array.isArray(customGuestRequestSubTitleStyle.fontFamilyArr) 
                                    ? customGuestRequestSubTitleStyle.fontFamilyArr 
                                    : [customGuestRequestSubTitleStyle.fontFamily]}
                                id={`adhocOfferListItemHeaderSubTitleText`}
                            />
                        </View>
                    </View>
                    {/* Bottom row: price + button */}
                    <View style={getStyles(["adhocOfferListItemOfferControlsContainer"])} id='adhocOfferListItemOfferControlsContainer'>
                        {!!qp.price && (
                            <Text style={getStyles(["adhocOfferListItemOfferControlsPrice"])} id='adhocOfferListItemOfferControlsPrice'>{currencyDetails?.code + qp.price}</Text>
                        )}
                        <View style={getStyles(["adhocOfferListButtonsContainer"])} id='adhocOfferListButtonsContainer'>
                            {isPending  ? (
                                <View style={getStyles(["primaryBtn", "adhocOfferListButtons"])} id='adhocOfferListButtons'>
                                    <ActivityIndicator size="small" color="#fff" />
                                    <Text style={getStyles(["primaryBtnTxt", "adhocOfferListButtonsText"])} id='primaryBtnTxt adhocOfferListButtonsText'>{t('adhoc.accepting')}</Text>
                                </View>
                            ) : isAccepted  ? (
                                <CustomPressable disabled style={getStyles(["primaryBtn", "adhocOfferListButtons"])} id='adhocOfferListButtons adhocOfferListButtonsDisabled'>
                                    <Text style={getStyles(["primaryBtnTxt", "adhocOfferListButtonsText"])} id='primaryBtnTxt adhocOfferListButtonsText'>{t('adhoc.accepted')}</Text>
                                </CustomPressable>
                            ) : (
                                <CustomPressable style={getStyles(["primaryBtn", "adhocOfferListButtons"])} id='primaryBtn adhocOfferListButtons' onPress={() => handleUpsellRequest(adhoc, qp.id)}>
                                    <Text style={getStyles(["primaryBtnTxt", "adhocOfferListButtonsText"])} id='primaryBtnTxt adhocOfferListButtonsText'>{t('adhoc.accept')}</Text>
                                </CustomPressable>
                            )}
                        </View>
                    </View>
                </View>
            );
        });
    };


    return adhocDataListLocalCopy.length != 0 && 
            <>
                <ScrollView automaticallyAdjustKeyboardInsets={true} contentContainerStyle={getStyles(['widgetmainContainer', 'adhocMainContainer'])} showsVerticalScrollIndicator={false}>
                    <View style={getStyles(['widgetmainContainerHeaderContainer', 'adhocHeaderContainer'])}>
                        <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'adhocHeaderTitleContainer'])}>
                            <Text style={getStyles(['widgetmainContainerHeaderTitle', 'adhocHeaderTitle'])}>{t('adhoc.heading')}</Text>
                            <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'adhocHeaderSubTitle'])}>{t('adhoc.sub_heading')}</Text>
                        </View>
                    </View>

                    <View style={getStyles(['widgetmainContainerChildContainer', 'adhocMainContainerChildContainer'])} id='widgetmainContainerChildContainer adhocMainContainerChildContainer'>
                        {!showSingleAdhoc.showSingleAdhocBool ? adhocDataListLocalCopy.map((adhoc) => (
                                <View key={`${adhoc.id}_${adhoc.type}`}>
                                    <CustomPressable 
                                        style={getStyles(["adhocOfferListItemHeaderContainer"])} 
                                        id='adhocOfferListItemHeaderContainer' 
                                        onPress={() => handleShowSingleAdhoc(adhoc)}
                                    >
                                        {!!adhoc.imageUri && (
                                            <ImageComp
                                                source={`${CMSPath}${AD_HOC_IMG_PATH}${adhoc.imageUri}`}
                                                style={getStyles(["adhocOfferListItemSubHeaderImage"])}
                                                id="adhocOfferListItemSubHeaderImage"
                                            />
                                        )}
                                        <View style={getStyles(["adhocOfferListItemMainHeaderTextContainer"])} id='adhocOfferListItemMainHeaderTextContainer'>
                                            
                                            <RenderHTML 
                                                contentWidth={width}
                                                source={{ html: adhoc.name || '' }} 
                                                baseStyle={Array.isArray(customGuestRequestMainTitleStyle.fontFamilyArr) 
                                                    ? {...customGuestRequestMainTitleStyle, fontFamily: customGuestRequestMainTitleStyle.fontFamilyArr[0]} 
                                                    : customGuestRequestMainTitleStyle}
                                                systemFonts={Array.isArray(customGuestRequestMainTitleStyle.fontFamilyArr) 
                                                    ? customGuestRequestMainTitleStyle.fontFamilyArr 
                                                    : [customGuestRequestMainTitleStyle.fontFamily]}
                                                id={`adhocOfferListItemMainHeaderTitleText`}
                                            />
                                            <RenderHTML
                                                contentWidth={width}
                                                source={{ html: adhoc.textMessage || '' }}
                                                baseStyle={Array.isArray(customGuestRequestMainSubTitleStyle.fontFamilyArr) 
                                                    ? {...customGuestRequestMainSubTitleStyle, fontFamily: customGuestRequestMainSubTitleStyle.fontFamilyArr[0]} 
                                                    : customGuestRequestMainSubTitleStyle}
                                                systemFonts={Array.isArray(customGuestRequestMainSubTitleStyle.fontFamilyArr) 
                                                    ? customGuestRequestMainSubTitleStyle.fontFamilyArr 
                                                    : [customGuestRequestMainSubTitleStyle.fontFamily]}
                                                id={`adhocOfferListItemHeaderMainSubTitleText`}
                                            />
                                        </View>
                                    </CustomPressable>

                                    {renderQualityPlusRequests(adhoc)}
                                </View>
                            ))
                        : adhocDataListLocalCopy.map((adhoc) =>
                            adhoc.id === showSingleAdhoc.adhocId && adhoc.type == showSingleAdhoc.adhocType ? (
                                <View key={`${adhoc.id}_${adhoc.type}`}>
                                    <View style={getStyles(["adhocListElementHeaderContainer"])} id='adhocListElementHeaderContainer'>
                                        {!!adhoc.imageUri && (
                                            <ImageComp
                                                source={`${CMSPath}${AD_HOC_IMG_PATH}${adhoc.imageUri}`}
                                                style={getStyles(["adhocListElementHeaderImage"])}
                                                id="adhocListElementHeaderImage"
                                            />
                                        )}
                                        <RenderHTML 
                                            contentWidth={width}
                                            source={{ html: adhoc.name || '' }} 
                                            baseStyle={Array.isArray(customGuestRequestMainTitleStyle.fontFamilyArr) 
                                                ? {...customGuestRequestMainTitleStyle, fontFamily: customGuestRequestMainTitleStyle.fontFamilyArr[0]} 
                                                : customGuestRequestMainTitleStyle}
                                            systemFonts={Array.isArray(customGuestRequestMainTitleStyle.fontFamilyArr) 
                                                ? customGuestRequestMainTitleStyle.fontFamilyArr 
                                                : [customGuestRequestMainTitleStyle.fontFamily]}
                                            id={`adhocOfferListItemHeaderTitleText`}
                                        />
                                        <RenderHTML 
                                            contentWidth={width}
                                            source={{ html: adhoc.textMessage || '' }}
                                            baseStyle={Array.isArray(customGuestRequestMainSubTitleStyle.fontFamilyArr) 
                                                ? {...customGuestRequestMainSubTitleStyle, fontFamily: customGuestRequestMainSubTitleStyle.fontFamilyArr[0]} 
                                                : customGuestRequestMainSubTitleStyle}
                                            systemFonts={Array.isArray(customGuestRequestMainSubTitleStyle.fontFamilyArr) 
                                                ? customGuestRequestMainSubTitleStyle.fontFamilyArr 
                                                : [customGuestRequestMainSubTitleStyle.fontFamily]}
                                            id={`adhocOfferListItemHeaderSubTitleText`}
                                        />
                                    </View>

                                    {renderQualityPlusRequests(adhoc)}
                                </View>
                            ) : null
                        )}
                    </View>
                </ScrollView>

                <View style={getStyles(['footerButtonContainer'])} id="footerButtonContainer">
                    <CustomPressable style={getStyles(['primaryBtn', 'adhocOfferListButtonsPrimary'])} onPress={() => handleSkip()}>
                        <Text style={getStyles(['primaryBtnTxt', 'adhocOfferListButtonsPrimaryText'])}>{t('adhoc.continue')}</Text>
                    </CustomPressable>

                    {showSingleAdhoc.showSingleAdhocBool && <CustomPressable style={getStyles(['secondaryBtn', 'adhocOfferListButtonsSecondary'])} onPress={handleBack}>
                        <Text style={getStyles(['secondaryBtnTxt', 'adhocOfferListButtonsSecondaryText'])}>{t('adhoc.back')}</Text>
                    </CustomPressable>}
                </View>
            </>
};
export default Adhoc_InHouse;